module.exports = __webpack_public_path__ + "static/jiva6-14597d273a0ee652c185d524713ecaa6.png";